import { Component, inject, Input, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/shared/services/auth.service';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';

@Component({
  selector: '[app-nav-inventory]',
  template: `
    <li><button #stock 
      *ngIf="authService.hasPermission('can_read_stock')"
      class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3" 
      routerLink="/inventory"
      >Inventario</button></li>
    <li><button #purchaseOrders 
    *ngIf="authService.hasPermission('can_read_purchase_orders')"
      class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3" 
      routerLink="/inventory/purchase-orders" 
    >Ordenes de compra</button></li>
    <li><button #providers 
      *ngIf="authService.hasPermission('can_read_suppliers')"
      class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3" 
      routerLink="/inventory/providers"
      >Proveedores</button></li>
    <li>
      <button #sales 
        *ngIf="authService.hasPermission('can_view_sales')"
        class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3" 
        routerLink="/inventory/sales"
      >Ventas</button>
    </li>
    <li>
      <button type="button" 
        *ngIf="authService.hasPermission('can_read_reports')"
        class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3" 
        (click)="downloadReport()"
      >
        Reporte proforma
      </button>
    </li>
    <li>
      <!--  *ngIf="authService.hasPermission('can_read_stock_assignments')"-->
      <button type="button"   
        class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3" 
        routerLink="/inventory/stock-assignments"
      >
        Asignaciones de inventario
      </button>
    </li>
  `,
  styles: ``
})
export class NavInventoryComponent {
  profile: any = {};
  permissions: any = {};
  @Input() currentView: string | null = null;
  @ViewChild('stock') stock !: any;
  @ViewChild('purchaseOrders') purchaseOrders !: any;
  @ViewChild('sales') sales !: any;
  @ViewChild('providers') providers !: any;
  storageService = inject(StorageService);
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    public authService: AuthService
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    this.permissions = this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) ? this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) : null;
  }

  ngAfterViewInit() {
    if (!this.currentView) return;
    const stockEl = this.stock?.nativeElement;
    const purchaseOrdersEl = this.purchaseOrders?.nativeElement;
    const providersEl = this.providers?.nativeElement;
    const salesEl = this.sales?.nativeElement;

    console.log('Current view:', this.currentView);

    if (this.currentView === 'stock') {
      stockEl?.classList.add('active');
      purchaseOrdersEl?.classList.remove('active');
      providersEl?.classList.remove('active');
      salesEl?.classList.remove('active');
    }
    else if (this.currentView === 'purchaseOrders') {
      stockEl?.classList.remove('active');
      purchaseOrdersEl?.classList.add('active');
      providersEl?.classList.remove('active');
      salesEl?.classList.remove('active');
    }
    else if (this.currentView === 'sales') {
      stockEl?.classList.remove('active');
      purchaseOrdersEl?.classList.remove('active');
      providersEl?.classList.remove('active');
      salesEl?.classList.add('active');
    }
    else if (this.currentView === 'providers') {
      stockEl?.classList.remove('active');
      purchaseOrdersEl?.classList.remove('active');
      providersEl?.classList.add('active');
      salesEl?.classList.remove('active');
    }
  }

  downloadReport() {
    const apiUrl = `https://receipt-test.zazz.mx/public/proforma_autogenerado.xlsx`;
    
    // Show loading message
    this.toastr.info('Generando reporte...', 'Por favor espere');
    
    // Make HTTP request to get the file
    this.http.get(apiUrl, {
      responseType: 'blob',
      headers: {
        'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
    }).subscribe({
      next: (blob: Blob) => {
        // Create a URL for the blob
        const url = window.URL.createObjectURL(blob);
        
        // Create a temporary anchor element
        const a = document.createElement('a');
        a.href = url;
        
        // Set filename with current date
        const currentDate = new Date().toISOString().split('T')[0]; // Format: YYYY-MM-DD
        a.download = `reporte_proforma_inventario_${currentDate}.xlsx`;
        
        // Append to body, click and remove
        document.body.appendChild(a);
        a.click();
        
        // Clean up
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        
        this.toastr.success('Reporte descargado correctamente', 'Éxito');
      },
      error: (error) => {
        console.error('Error downloading report:', error);
        this.toastr.error('No se pudo descargar el reporte', 'Error');
      }
    });
  }
}
